import React, { useEffect } from 'react';
import { navigate } from '../utils/navigation';
import { useAuth } from '../contexts/AuthContext';

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
    navigate('/prenup/SystemUser/Login');
  }, [logout]);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-auto text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="sr-only">جاري تسجيل الخروج...</span>
          </div>
          <h5>جاري تسجيل الخروج...</h5>
        </div>
      </div>
    </div>
  );
};

export default Logout;
